import { graphql } from "gatsby";
import BodyBanner from "../banners/bodyBanner";
import TitleBanner from "../banners/titleBanner";
import TitleSubheadingBanner from "../banners/titleSubheadingBanner";
import TitleCTABanner from "../banners/titleCTABanner";
import TitleCTAIconBanner from "../banners/titleCTAIconBanner";
import CardGalleryBanner from "../banners/cardGallery";

const getBannerClass = (bannerType) => {
  switch (bannerType) {
    case "Body-banner":
      return "body";
    case "Title-banner":
      return "title";
    case "Title-subheading-banner":
      return "title-subheading";
    case "Title-CTA-banner":
      return "title-cta";
    case "Title-CTA-icon-banner":
      return "title-cta-icon";
    case "Card-Gallery":
      return "card-gallery";
    default:
      return "body";
  }
};

const getBanner = (bannerData, blockIndex, forceH1, breadcrumbSettings) => {
  const { bannerType } = bannerData;
  const bannerClass = getBannerClass(bannerType);

  switch (bannerType) {
    case "Body-banner":
      return BodyBanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
    case "Title-banner":
      return TitleBanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
    case "Title-subheading-banner":
      return TitleSubheadingBanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
    case "Title-CTA-banner":
      return TitleCTABanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
    case "Title-CTA-icon-banner":
      return TitleCTAIconBanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
    case "Card-Gallery":
      return CardGalleryBanner(bannerData, forceH1, breadcrumbSettings);
    default:
      return BodyBanner(bannerClass, bannerData, blockIndex, forceH1, breadcrumbSettings);
  }
};

const Banner = ({ bannerData, blockIndex = null, forceH1 = false, breadcrumbSettings = null }) => {
  return getBanner(bannerData, blockIndex, forceH1, breadcrumbSettings);
};

export default Banner;

export const query = graphql`
  fragment Banner on ContentfulBanner {
    id
    anchor
    bannerType
    title
    bodyCopy
    buttonText
    buttonLink
    buttonType
    backgroundColor
    bannerImage {
      ...ImageFixed
    }
    fullBleedImage
    imagePosition
    icon
    bannerDivider
    objectFit
  }
`;
